module.exports = __webpack_public_path__ + "static/media/covid2.fbe044c5.png";